module.exports = __webpack_public_path__ + "static/img/success.41f20215.png";